/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import { GET_FIELD } from '@nile/banyan/src/Graphql/Mutations/ticket';
import {
  ActionGroup,
  FeatureGuide,
  AccessControl,
  getTranslatedText,
  Icon,
  Loader,
  preFormatForm,
  TEXT_LENGTH,
  ticketStatusConstraints,
  validateForm,
  useIntl,
  ALL_SHARD_MODULES,
  DEFAULT_FIELDS_BY_COLUMN_NAME,
  getParsedCrudData
} from '@nile/components';
import { AccountClient, useQuery } from '@nile/graphql/src';
import {
  Heading,
  Page,
  TextContainer,
  TextStyle,
  Button,
  DisplayText,
  FormLayout,
  ResourceItem,
  ResourceList,
  TextField
} from '@superops/ui-design-system';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Check, Plus, Times } from '@styled-icons/fa-solid';
import { SVGIcon } from '@superops/super-icons';
import nanoid from 'nanoid';
import { isEmpty, pick, sortBy } from 'lodash';
import { SuperSortable } from '@nile/components/src/SuperSortable/SuperSortable';
import { useFlags } from 'launchdarkly-react-client-sdk';

const TicketStyled = styled.div`
  width: 100%;
  &.edit {
    width: 100%;
    margin: 0;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  #addStatusDescription {
    min-height: 2.6rem;
    min-width: 2.6rem;
    height: 25px;
    padding: 0 !important;
  }
  #ticketStatusDescription {
    border-bottom: none;
  }
`;

const StatusCrudWrapper = styled.div`
  width: 70%;
`;

const NewTicketStatus = (props) => {
  const { intl, onCancel, disableSort } = props;
  const [name, setName] = useState(props?.item?.value || '');
  const [description, setDescription] = useState(
    props?.item?.description || ''
  );
  const [errors, setErrors] = useState(props?.errors || null);
  const onSuccessHandler = () => {
    const formObj = { name, description };
    const validationResult = validateForm(
      preFormatForm(formObj),
      ticketStatusConstraints
    );
    if (validationResult) {
      setErrors(validationResult);
      return;
    }
    if (props?.mode === 'edit') {
      props.onSuccess({ ...props.item, name, description });
    } else {
      props.onSuccess(name, description);
    }
    setErrors({});
    setName('');
    setDescription('');
  };

  return (
    <TicketStyled
      className={
        props?.mode === 'edit'
          ? 'fx Ticket-Status-Form edit'
          : 'fx Ticket-Status-Form'
      }
      style={props?.mode !== 'edit' ? { marginBottom: 20 } : {}}
    >
      <div className="grow-2">
        <FormLayout>
          <div className="ml-20 mr-20">
            <div className="flex actr g5">
              {props?.mode === 'edit' &&
                props?.isEditAuthorised &&
                !disableSort && (
                  <div>
                    <SuperSortable.DragHandle className="self-center" />
                  </div>
                )}
              <div className="w100">
                <TextField
                  id="ticketStatusName"
                  value={name}
                  name="name"
                  onChange={(val) => {
                    setErrors({});
                    setName(val);
                  }}
                  placeholder={getTranslatedText(
                    intl,
                    'admin.Ticketstatus.pl.add'
                  )}
                  type="text"
                  error={errors?.name?.[0]}
                  maxLength={TEXT_LENGTH.size_4}
                />
              </div>
            </div>

            <TextField
              id="ticketStatusDescription"
              value={description}
              multiline
              name="description"
              onChange={(val) => {
                setErrors({});
                setDescription(val);
              }}
              noborder
              placeholder={getTranslatedText(
                intl,
                'admin.Ticketstatus.pl.desc'
              )}
              type="text"
              error={errors?.description?.[0]}
              maxLength={TEXT_LENGTH.size_6}
            />
          </div>
        </FormLayout>
      </div>
      <div className="fx actr jend mr-20" superid="TicketStatusUpdate">
        {props?.mode === 'edit' ? (
          <AccessControl
            roleToCheck="customFields.edit"
            render={
              <Button
                id="addStatusDescription"
                onClick={onSuccessHandler}
                icon={<SVGIcon name="Check" size="sm" />}
              />
            }
          />
        ) : (
          <AccessControl
            roleToCheck="customFields.edit"
            render={
              <Button
                id="addStatusDescription"
                onClick={onSuccessHandler}
                plain
                icon={<SVGIcon name="Add" size="sm" />}
              />
            }
          />
        )}
        {props?.mode === 'edit' && (
          <div className="ml-10">
            <AccessControl
              roleToCheck="customFields.edit"
              render={
                <Button
                  id="addStatusDescription"
                  onClick={onCancel}
                  icon={<SVGIcon name="Close" size="sm" />}
                />
              }
            />
          </div>
        )}
      </div>
    </TicketStyled>
  );
};

const SingleStatus = (props) => {
  const {
    updateStatus,
    deleteStatus,
    intl,
    selectedItem,
    setSelectedItem,
    isEditAuthorised,
    disableSort
  } = props;

  const id = props?.item?.id || null;
  const name = props?.item?.value;
  const description = props?.item?.description;

  const onCancel = () => {
    setSelectedItem(null);
  };

  const onEditSuccess = (updatedData) => {
    setSelectedItem(null);
    updateStatus(updatedData);
  };

  return (
    <React.Fragment key={id}>
      <div className="hiddenContainer w100">
        {selectedItem?.id === id ? (
          <NewTicketStatus
            intl={intl}
            item={props?.item}
            onSuccess={onEditSuccess}
            mode="edit"
            onCancel={onCancel}
            isEditAuthorised={isEditAuthorised}
            disableSort={disableSort}
          />
        ) : (
          <ResourceItem id={id} accessibilityLabel={`View details for ${name}`}>
            <div className="flex g5 w100">
              {isEditAuthorised && !disableSort && (
                <div>
                  <SuperSortable.DragHandle className="self-center" />
                </div>
              )}

              <div className="w100">
                <div className="fx w100">
                  <div className="fx fx2 actr">
                    <TextStyle weight="Bold">{name || 'No content'}</TextStyle>
                  </div>
                  <div className="fx" superid="UpdateTicketStatusDetails">
                    <AccessControl
                      roleToCheck="customFields.edit"
                      render={
                        <div
                          onClick={() => setSelectedItem(props?.item)}
                          className="mr-10 hiddenFxActions"
                        >
                          <SVGIcon name="Edit" />
                        </div>
                      }
                    />
                    <AccessControl
                      roleToCheck="customFields.edit"
                      render={
                        <>
                          {!props.item?.constants && (
                            <div
                              className="hiddenFxActions"
                              onClick={() => deleteStatus(props?.item)}
                            >
                              <SVGIcon name="Delete" />
                            </div>
                          )}
                        </>
                      }
                    />
                  </div>
                </div>
                <div>
                  <DisplayText element="p" size="medium" weight="Bold">
                    <TextStyle variation="subdued">
                      {description ||
                        getTranslatedText(intl, 'admin.Ticketstatus.noDesc')}
                    </TextStyle>
                  </DisplayText>
                </div>
              </div>
            </div>
          </ResourceItem>
        )}
      </div>
    </React.Fragment>
  );
};

const StatusCRUD = (props) => {
  const {
    allStatuses,
    updateStatus,
    addStatus,
    deleteStatus,
    updateOrder,
    isEditAuthorised,
    disableSort
  } = props;

  const [selectedItem, setSelectedItem] = useState('');

  const sortedStatus = allStatuses ? sortBy(allStatuses, 'order') : [];

  const intl = useIntl();

  return (
    <>
      <div className="mt-16">
        <Heading element="h2">
          <FormattedMessage id="admin.Ticketstatus.h2" />
        </Heading>
        <NewTicketStatus intl={intl} onSuccess={addStatus} />
        <div className="ticket-all-status">
          {!isEmpty(sortedStatus) && (
            <SuperSortable
              className="sort-wrapper"
              list={sortedStatus || []}
              onDragEnd={(data) => {
                const updatedDataWithOrder = data.map((field, i) => ({
                  ...field,
                  order: i + 1
                }));
                updateOrder(updatedDataWithOrder);
              }}
              animation={200}
            >
              {sortedStatus.map((item) => {
                return (
                  <React.Fragment key={item?.id}>
                    <div className="flex w100  br-5 pl10">
                      <SingleStatus
                        updateStatus={updateStatus}
                        deleteStatus={deleteStatus}
                        item={item}
                        intl={intl}
                        selectedItem={selectedItem}
                        setSelectedItem={setSelectedItem}
                        isEditAuthorised={isEditAuthorised}
                        disableSort={disableSort}
                      />
                    </div>
                  </React.Fragment>
                );
              })}
            </SuperSortable>
          )}
        </div>
      </div>
    </>
  );
};

function TicketStatus(props) {
  const { isEditAuthorised, disableSort } = props;
  const [allStatuses, setAllStatuses] = useState([]);
  const flags = useFlags();

  const allStatusesByRef = React.useRef(null);
  allStatusesByRef.current = allStatuses;

  const { data: statusData, refetch: refetchStatuses, loading } = useQuery(
    GET_FIELD,
    {
      client: AccountClient,
      fetchPolicy: 'network-only',
      variables: {
        input: {
          entity: ALL_SHARD_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS
        }
      },
      onCompleted({ getField }) {
        if (getField?.options || getField?.fieldOptions) {
          setAllStatuses(getField?.options || getField?.fieldOptions);
        }
      }
    }
  );

  const deleteStatus = (deletedStatus) => {
    let updatedData = [...allStatusesByRef.current];
    updatedData = updatedData.filter((el) => {
      return el?.id !== deletedStatus?.id;
    });
    setAllStatuses(updatedData);
  };

  const addStatus = (name, desc) => {
    const baseStatus = [...allStatusesByRef.current];
    const addedStatus = {
      id: nanoid(),
      value: name,
      description: desc,
      order: baseStatus?.length ? baseStatus?.length + 1 : 1
    };
    const updatedData = [...baseStatus, addedStatus];
    setAllStatuses(updatedData);
  };

  const updateStatus = (updatedStatus) => {
    const value = updatedStatus?.name;
    const description = updatedStatus?.description;
    let updatedData = [...allStatusesByRef.current];

    updatedData = updatedData.map((el) => {
      let object = {};
      if (el?.id === updatedStatus?.id) {
        object = {
          ...el,
          value: value,
          description: description
        };
      } else {
        object = { ...el };
      }
      return object;
    });

    setAllStatuses(updatedData);
  };

  const onSave = () => {
    const baseData =
      statusData?.getField?.options || statusData?.getField?.fieldOptions;
    const updatedData = allStatusesByRef.current;

    let updatedOptions = {};

    const result = getParsedCrudData(baseData, updatedData);
    const { addedItems, deletedItems, updatedItems } = result;

    if (addedItems.length > 0) {
      const added = addedItems.map(({ id, ...keepAttrs }) => keepAttrs);
      updatedOptions = { ...updatedOptions, added: added, addOptions: added };
    }

    if (deletedItems.length > 0) {
      updatedOptions = {
        ...updatedOptions,
        deleted: deletedItems,
        deleteOptions: deletedItems
      };
    }

    if (updatedItems.length > 0) {
      updatedOptions = {
        ...updatedOptions,
        updated: updatedItems,
        updateOptions: updatedItems
      };
    }

    if (!isEmpty(updatedOptions)) {
      let variables = {
        id: statusData?.getField?.id
      };
      variables = flags?.dependentField
        ? {
            ...variables,
            addOptions: updatedOptions?.addOptions?.map((el) =>
              pick(el, ['value', 'description', 'order', 'parentOption'])
            ),
            updateOptions: updatedOptions?.updateOptions?.map((el) =>
              pick(el, ['value', 'description', 'order', 'id'])
            ),
            deleteOptions: updatedOptions?.deleteOptions?.map((el) =>
              pick(el, ['id'])
            )
          }
        : { ...variables, fieldOptionsInput: JSON.stringify(updatedOptions) };

      props.primaryAction(variables);
    } else {
      props.setModalActive(false);
    }
  };

  return (
    <div className="full-height full-width">
      <Page
        variant="primary"
        fullWidth
        contentHeight="140px"
        subtitle={
          <>
            <TextContainer>
              <TextStyle variation="subdued">
                <FormattedMessage id="admin.Ticketstatus.header.label" />
              </TextStyle>
            </TextContainer>
            <div className="mt10">
              <FeatureGuide featureName="status" article />
            </div>
          </>
        }
        title={
          <Heading element="h1">
            <FormattedMessage id="admin.Ticketstatus.header" />
          </Heading>
        }
        primaryAction={
          <ActionGroup
            primaryText={<FormattedMessage id="common.save" />}
            primaryLoading={props.saveLoading}
            primaryAction={onSave}
            secondaryAction={props.secondaryAction}
            primaryDisabled={!isEditAuthorised}
          />
        }
      >
        {loading ? (
          <Loader />
        ) : (
          <>
            <StatusCrudWrapper>
              <StatusCRUD
                allStatuses={allStatusesByRef.current}
                addStatus={addStatus}
                deleteStatus={deleteStatus}
                updateStatus={updateStatus}
                updateOrder={setAllStatuses}
                isEditAuthorised={isEditAuthorised}
                disableSort={disableSort}
              />
            </StatusCrudWrapper>
          </>
        )}
      </Page>
    </div>
  );
}

export default TicketStatus;
